<template>
    <span
        class="text-danger text-sm"
        v-if="error.has(field, scope)">
        {{ error.first(field, scope) }}
    </span>
</template>

<script>
export default {
    name: "ValidateText",
    props: {
        field: {
            type: String,
            required: true,
        },
        scope: {
            type: String,
            default: '',
        },
        error: {
            type: Object,
            required: true,
        }
    },
}
</script>

<style scoped lang="scss">

</style>
